import React, { type ReactNode } from 'react';

import { parseTextWithUrls } from './parseTextWithUrls';
import { processMixedContent } from './processMixedContent';

export const processTextContent = (
  children: ReactNode,
  detectUrls: boolean,
  parentElement: HTMLElement | null,
  showUrlsIcons: boolean,
): ReactNode => {
  if (!detectUrls) return children;

  if (typeof children === 'string') {
    return parseTextWithUrls(children, parentElement, showUrlsIcons);
  }

  if (React.isValidElement(children) || Array.isArray(children)) {
    return processMixedContent(children, parentElement, showUrlsIcons);
  }

  return children;
};
